module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui fluid container"
  }, [_vm._m(0), _vm._v(" "), _c('app-menu'), _vm._v(" "), _c('div', {
    staticClass: "pusher"
  }, [_c('transition', {
    attrs: {
      "name": "component-transition"
    }
  }, [_c('router-view')], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "ui black right corner huge label",
    attrs: {
      "href": "https://www.github.com/guilhermewaess/SemVue",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "github icon"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51d580a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 147
// module chunks = 1